export default __webpack_public_path__ + "static/private-boat-hire-cad38957795c22ed92a9ce5f793ee411.jpg";